import { Link } from "@labs/schema";
import React from "react";
export default function BackLink(param) {
    var link = param.link, label = param.label;
    return /*#__PURE__*/ React.createElement("div", {
        className: "inline-block md:block text-center"
    }, /*#__PURE__*/ React.createElement(Link, {
        href: link,
        className: "inline-block focus text-center md:inline-flex md:items-center md:justify-center"
    }, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "33",
        height: "12",
        viewBox: "0 0 33 12",
        fill: "none",
        className: "mr-4 mob:mx-auto"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M33 5.3109L2.66428 5.3109L7.04419 0.974389L6.06005 0L0 6L6.06005 12L7.04419 11.0256L2.66428 6.6891L33 6.6891V5.3109Z",
        fill: "#00A29A"
    })), /*#__PURE__*/ React.createElement("span", {
        className: "text-turquoise-500 text-[0.85rem] lg:text-sm"
    }, label)));
}
